<mat-card>
    <mat-card-title>Staff List</mat-card-title>
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="users" class="full-width-table">
  
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let u">
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>⋮</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="onView(u.id)">
                <mat-icon>View</mat-icon>
              </button>
              <button mat-menu-item (click)="onActiveInActive(u.id, u.is_active)">
                <mat-icon *ngIf="u.is_active">Inactive</mat-icon>
                <mat-icon *ngIf="!u.is_active">Active</mat-icon>
              </button>
            </mat-menu>
          </td>
        </ng-container>
  
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let u"> {{ u.name }} </td>
        </ng-container>
  
        <!-- Staff ID Column -->
        <ng-container matColumnDef="staff_id">
          <th mat-header-cell *matHeaderCellDef> Staff ID </th>
          <td mat-cell *matCellDef="let u"> {{ u.staff_id }} </td>
        </ng-container>
  
        <!-- Phone Column -->
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef> Phone </th>
          <td mat-cell *matCellDef="let u"> {{ u.phone }} </td>
        </ng-container>
  
        <!-- Designation Column -->
        <ng-container matColumnDef="designation">
          <th mat-header-cell *matHeaderCellDef> Designation </th>
          <td mat-cell *matCellDef="let u"> {{ u.designation }} </td>
        </ng-container>
  
        <!-- Course IDs Column -->
        <ng-container matColumnDef="course_ids">
          <th mat-header-cell *matHeaderCellDef> Course IDs </th>
          <td mat-cell *matCellDef="let u"> {{ u.course_ids?.join(', ') }} </td>
        </ng-container>
  
        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let u"> {{ u.email }} </td>
        </ng-container>
  
        <!-- Header and Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </mat-card>
  